import React from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH, MOBILE_WIDTH } from '../../constants/dims';
import imgResearch from '../../assets/img/research.png';

const Section = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  color: ${props => props.theme.research.text};
  background-color: ${props => props.theme.research.backgroundColor};
  padding: 32px;
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: ${TABLET_WIDTH}px;
  text-align: center;
`;

const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  & > div {
    max-width: 840px;
    text-align: center;
  }
`;

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
`;

const Column = styled.div`
  flex: 1 1 300px;
  min-width: 300px;
  text-align: left;
  box-sizing: border-box;
  margin-bottom: 24px;
  padding-right: 24px;

  &:last-child {
    padding-right: 0;
    margin-bottom: 0;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      padding-left: 0;
    }
  }
`;

const Header = styled.div`
  padding: 20px;
  box-sizing: border-box;
`;

const Research = () => {
  return (
    <Section id="research">
      <Container>
        <Header>
          <h2>
            Independent researchers who don’t work for BrainQuake evaluate our
            efficacy
          </h2>
          <h5>
            We’re parents and teachers, too, and just like you, we need to see
            the proof that our products work.
          </h5>
        </Header>

        <ImgWrapper>
          <div>
            <img src={imgResearch} alt="" />
          </div>
        </ImgWrapper>

        <Columns>
          <Column>
            <h4>Ongoing research</h4>
            <p>
              So far, two universities have published independent, peer-reviewed
              comparison-group studies demonstrating the efficacy of our work.
              BrainQuake never funds nor conducts these studies, and we are always
              open to supporting new research.
            </p>
          </Column>

          <Column>
            <h4>Results</h4>
            <p>
              On average, children’s problem-solving skills improve by 16.4%
              after two hours of learning over the course of one month.
            </p>
          </Column>

          <Column>
            <h4>More to come</h4>
            <p>
              Improved math problem-solving skills likely mean better
              problem-solving skills in all subject areas. In an economy that
              demands creative, cross-disciplinary problem-solving skills, we’re
              investigating how our work develops those very skills.
            </p>
          </Column>
        </Columns>
      </Container>
    </Section>
  );
};

export default Research;
